// Data fetching
export const GET_VOUCHER_FOLLOWUP_REQUEST = 'GET_VOUCHER_FOLLOWUP_REQUEST';
export const GET_VOUCHER_FOLLOWUP_SUCCESS = 'GET_VOUCHER_FOLLOWUP_SUCCESS';
export const GET_VOUCHER_FOLLOWUP_FAILURE = 'GET_VOUCHER_FOLLOWUP_FAILURE';
